import styles from "./BundleClaimErrorModal.module.scss"
import { validateClaimability } from "./bundleClaimValidation"

import ModalDialog from "@/main/components/ui/ModalDialog/ModalDialog"
import { CancelForListFragment } from "@/main/gql/__generated__/graphql"
import { useCancelTypeInfos } from "@/main/lib/useCancelTypeInfos"
import { useMediaQueryContext } from "@/provider/MediaQueryProvider"

type Props = {
	isOpen: boolean
	onClose: () => void
	failedCancels: CancelForListFragment[]
}

const BundleClaimErrorModal = ({ isOpen, onClose, failedCancels }: Props) => {
	const { getCancelTypeLabel } = useCancelTypeInfos()
	const { isMobile } = useMediaQueryContext()

	return (
		<ModalDialog
			isOpen={isOpen}
			onOpenChange={(open) => {
				if (!open) onClose()
			}}
			contentClassName={
				isMobile ? styles.sp_modal_content : styles.modal_content
			}
		>
			{isMobile ? (
				<div className={styles.sp_modal_card}>
					<div className={styles.sp_warning_banner}>
						<span className={styles.warning_icon}>⚠</span>
						<span className={styles.sp_warning_text}>
							請求できないキャンセルが含まれています
						</span>
					</div>
					<p className={styles.sp_error_desc}>
						以下のキャンセルは情報が不足しているため請求できません。選択から外すか、情報を編集してください。
					</p>
					<div className={styles.sp_card_list}>
						{failedCancels.map((cancel) => {
							const validateResult = validateClaimability(cancel)
							return (
								<div key={cancel.idv2} className={styles.sp_err_card}>
									<div className={styles.sp_card_header}>
										<span className={styles.sp_card_name}>{cancel.name}</span>
									</div>
									<div className={styles.sp_card_row}>
										<span className={styles.sp_label}>キャンセル種別:</span>
										<span
											className={
												validateResult.invalidCancelType
													? styles.error_text
													: ""
											}
										>
											{validateResult.invalidCancelType
												? "—"
												: getCancelTypeLabel(cancel.cancelType)}
										</span>
									</div>
									<div className={styles.sp_card_row}>
										<span className={styles.sp_label}>電話番号:</span>
										<span
											className={
												validateResult.invalidPhone ? styles.error_text : ""
											}
										>
											{cancel.phoneNumber || "—"}
										</span>
									</div>
									<div className={styles.sp_card_row}>
										<span className={styles.sp_label}>来店予定日:</span>
										<span>{cancel.dateVisit}</span>
									</div>
									<div className={styles.sp_card_row}>
										<span className={styles.sp_label}>担当スタッフ:</span>
										<span>{cancel.staffName || "—"}</span>
									</div>
									<div className={styles.sp_card_row}>
										<span className={styles.sp_label}>不足情報:</span>
										<ul className={styles.error_text}>
											{validateResult.reasons.map((reason) => (
												<li key={reason}>{reason}</li>
											))}
										</ul>
									</div>
								</div>
							)
						})}
					</div>
					<button className={styles.sp_close_btn} onClick={onClose}>
						閉じる
					</button>
				</div>
			) : (
				<div className={styles.modal_card}>
					<div className={styles.warning_banner}>
						<span className={styles.warning_icon}>⚠</span>
						<span className={styles.warning_text}>
							請求できないキャンセルが含まれています
						</span>
					</div>
					<p className={styles.error_desc}>
						以下のキャンセルは電話番号などの情報が不足しているため請求できません。
						<br />
						該当のキャンセルを選択から外すか、情報を編集してから再度お試しください。
					</p>
					<div className={styles.error_table}>
						<div className={styles.table_header}>
							<span className={styles.col_name}>請求先</span>
							<span className={styles.col_cancel_type}>キャンセル種別</span>
							<span className={styles.col_phone}>電話番号</span>
							<span className={styles.col_date}>来店予定日</span>
							<span className={styles.col_staff}>担当スタッフ</span>
							<span className={styles.col_reason}>不足情報</span>
						</div>
						{failedCancels.map((cancel) => {
							const validateResult = validateClaimability(cancel)
							return (
								<div key={cancel.idv2} className={styles.table_row}>
									<span className={styles.col_name}>{cancel.name}</span>
									<span
										className={`${styles.col_cancel_type} ${
											validateResult.invalidCancelType ? styles.error_text : ""
										}`}
									>
										{validateResult.invalidCancelType
											? "—"
											: getCancelTypeLabel(cancel.cancelType)}
									</span>
									<span
										className={`${styles.col_phone} ${
											validateResult.invalidPhone ? styles.error_text : ""
										}`}
									>
										{cancel.phoneNumber || "—"}
									</span>
									<span className={styles.col_date}>{cancel.dateVisit}</span>
									<span className={styles.col_staff}>
										{cancel.staffName || "—"}
									</span>
									<ul className={`${styles.col_reason} ${styles.error_text}`}>
										{validateResult.reasons.map((reason) => (
											<li key={reason}>{reason}</li>
										))}
									</ul>
								</div>
							)
						})}
					</div>
					<div className={styles.modal_buttons}>
						<button className={styles.close_btn} onClick={onClose}>
							閉じる
						</button>
					</div>
				</div>
			)}
		</ModalDialog>
	)
}

export default BundleClaimErrorModal
